<template>
  <div class="mn_footer">
    <p class="mw" style="text-align: left;">©2016 ᠥᠪᠥᠷ ᠮᠣᠩᠭᠣᠯ ᠤ᠋ᠨ ᠣᠶᠤᠨ ᠮᠡᠳᠡᠭᠡ ᠵᠠᠩᠭᠢ ᠮᠡᠷᠭᠡᠵᠢᠯ ᠦ᠋ᠨ ᠬᠢᠵᠠᠭᠠᠷᠲᠤ ᠺᠣᠮᠫᠠᠨᠢ ᠬᠡᠪᠯᠡᠯ   ᠦ᠋ᠨ ᠡᠷᠬᠡ ᠲᠠᠢ</p>
    <p style="text-align: center;">
      <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=15010502001520" target="_blank" style="display: inline-block; color: inherit; margin: 0px 10px;">
        <img src="../../assets/images/baImg.png">蒙公网安备 15010502001520号
      </a>
      <a href="http://beian.miit.gov.cn/" target="_blank" style="color: inherit;">蒙ICP备18000606号-1</a>
    </p>
  </div>
</template>
<script>
import AOS from 'aos'

export default {
  activated () {
    AOS.init()
  }
}
</script>
<style lang="scss" scoped>
.pageContainer {

}
</style>



// WEBPACK FOOTER //
// src/components/mobileFooterMN/index.vue